import { getAlteredDateByAddingDates } from '../util/DateTimeUtils';
import { SYSTEM_STAT_BAR_WIDGETS } from './StatBarConstants';

export const GLOBAL_CONFIG_TYPES = {
  ALL_USERS: 1,
  NEW_USERS: 2,
};

export const GLOBAL_CONFIG_FEATURES = {
  ENTITY_TABLE_LIST_VIEW: 'entity_table_list_view',
  PROFILE_PINNED_ATTRIBUTE_360: 'profile_pinned_attributes',
  STAT_BAR: 'stat_bar',
};

export const PINNED_ATTRIBUTE_TYPES = {
  SYSTEM: 1,
  CUSTOM: 2,
};

export const GLOBAL_CONFIG_NAMESAPCE = {
  LIST_VIEW: 'LISTVIEW',
  PINNED_ATTRIBUTE: 'PINNEDATTRIBUTE',
  STAT_BAR: 'STATBAR',
};

export const GLOBAL_CONFIG_FEATURE_INFO = {
  PINNED_ATTRIBUTES:
    'Choose which attributes users see in the 360 Profile Pinned Attributes section for each Entity layer.',
  LIST_VIEW:
    'Choose which columns users see in the table list view for each Entity layer.',
  STAT_BAR:
    'Choose the attributes displayed in the Stats bar list view and 360 Profile for each Entity layer.',
};

// Creating a map to directly link feature keys to their descriptions
export const FEATURE_TO_INFO_MAP = {
  entity_table_list_view: GLOBAL_CONFIG_FEATURE_INFO.LIST_VIEW,
  profile_pinned_attributes: GLOBAL_CONFIG_FEATURE_INFO.PINNED_ATTRIBUTES,
  stat_bar: GLOBAL_CONFIG_FEATURE_INFO.STAT_BAR,
};

export const FEATURE_TO_KEY_MAP = {
  [GLOBAL_CONFIG_FEATURES.ENTITY_TABLE_LIST_VIEW]:
    GLOBAL_CONFIG_NAMESAPCE.LIST_VIEW,
  [GLOBAL_CONFIG_FEATURES.PROFILE_PINNED_ATTRIBUTE_360]:
    GLOBAL_CONFIG_NAMESAPCE.PINNED_ATTRIBUTE,
  [GLOBAL_CONFIG_FEATURES.STAT_BAR]: GLOBAL_CONFIG_NAMESAPCE.STAT_BAR,
};

const DEFAULT_RENEWAL_DATE_COUNT = 14;

export const GLOBAL_CONFIG_STAT_BAR_WIDGET_DATA = {
  [SYSTEM_STAT_BAR_WIDGETS.HEALTH]: {
    count: { Red: 2, Amber: 5, Green: 104 },
    mrr: { Red: 5, Amber: 10, Green: 9 },
    arr: { Red: 10, Amber: 13, Green: 12 },
    currencyCode: 'USD',
  },
  [SYSTEM_STAT_BAR_WIDGETS.RENEWALS]: {
    count: 4,
    mrr: 3456,
    arr: 29990,
    currencyCode: 'USD',
    timeValue: 1,
    timeUnit: 'month',
  },
  [SYSTEM_STAT_BAR_WIDGETS.CSM_PULSE]: {
    count: {
      1: 93,
      2: 57,
      3: 82,
      4: 96,
      5: 63,
    },
    mrr: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
    },
    arr: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
    },
    currencyCode: 'USD',
  },
  [SYSTEM_STAT_BAR_WIDGETS.LIFECYCLE_STAGES]: {
    data: [
      {
        order: '1|k',
        displayName: 'Lead Acquisition',
        count: 4687,
        mrr: 1500,
        arr: 2000,
      },
      {
        order: '1|lcmf',
        displayName: 'Lead Nurturing',
        count: 3445,
        mrr: 1200,
        arr: 1800,
      },
      {
        order: '1|lcme1',
        displayName: 'Opportunity Development',
        count: 3456,
        mrr: 1400,
        arr: 2100,
      },
      {
        order: '1|lcmd',
        displayName: 'Onboarding',
        count: 4455,
        mrr: 0,
        arr: 0,
      },
      {
        order: '1|j',
        displayName: 'Pending Deletion',
        count: 2345,
        mrr: 0,
        arr: 0,
      },
      {
        order: '1|lcme2',
        displayName: 'Live',
        count: 4234,
        mrr: 1600,
        arr: 2200,
      },
    ],
    currencyCode: 'USD',
  },
  [SYSTEM_STAT_BAR_WIDGETS.NPS]: {
    breakdown: {
      total: 5,
      promoter: 0,
      passive: 0,
      detractor: 5,
    },
    score: '-100',
  },
  [SYSTEM_STAT_BAR_WIDGETS.CSAT]: {
    breakdown: {
      total: 5,
      satisfied: 2,
      verySatisfied: 1,
      neutral: 2,
      dissatisfied: 0,
      veryDissatisfied: 0,
    },
    score: '60%',
  },
  [SYSTEM_STAT_BAR_WIDGETS.PIPELINES_OVERVIEW]: {
    count: {
      1: 514,
      2: 127,
    },
    mrr: {
      1: 1979.93700449955,
      2: 20006,
    },
    currencyCode: 'USD',
  },
  [SYSTEM_STAT_BAR_WIDGETS.ENTITY_PIPELINES]: {
    count: {
      1: 1,
      2: 0,
    },
    mrr: {
      1: 60,
      2: 0,
    },
    currencyCode: 'USD',
  },
  [SYSTEM_STAT_BAR_WIDGETS.NUMBER_OF_ACCOUNTS]: {
    level: 'account',
    label: 'Number of Accounts',
    value: 4800,
  },
  [SYSTEM_STAT_BAR_WIDGETS.NUMBER_OF_CONTACTS]: {
    level: 'contact',
    label: 'Number of Contacts',
    value: 4800,
  },
  [SYSTEM_STAT_BAR_WIDGETS.NUMBER_OF_ORGANIZATIONS]: {
    level: 'organization',
    label: 'Number of Organizations',
    value: 4800,
  },
  [SYSTEM_STAT_BAR_WIDGETS.NUMBER_OF_LINKED_ORGANIZATIONS]: {
    level: 'organization',
    label: 'Active Organizations',
    value: 34,
  },
  [SYSTEM_STAT_BAR_WIDGETS.NUMBER_OF_LINKED_ACCOUNTS]: {
    level: 'account',
    label: 'Active Accounts',
    value: 45,
  },
  [SYSTEM_STAT_BAR_WIDGETS.NUMBER_OF_LINKED_CONTACTS]: {
    level: 'contact',
    label: 'Active Contacts',
    value: 346,
  },
  // 360 ATTRIBUTES
  [SYSTEM_STAT_BAR_WIDGETS.HEALTH_360]: {
    status: 'Green',
    score: '8.0',
  },
  [SYSTEM_STAT_BAR_WIDGETS.RENEWAL_360]: {
    renewalDate: getAlteredDateByAddingDates(DEFAULT_RENEWAL_DATE_COUNT),
  },
  [SYSTEM_STAT_BAR_WIDGETS.CSM_PULSE_360]: {
    pulse: 4,
  },
  [SYSTEM_STAT_BAR_WIDGETS.LIFECYCLE_STAGE_360]: {
    displayName: 'Stage 2',
  },
  [SYSTEM_STAT_BAR_WIDGETS.NPS_360]: {
    breakdown: {
      total: 0,
      promoter: 0,
      passive: 0,
      detractor: 0,
    },
    score: null,
  },
  [SYSTEM_STAT_BAR_WIDGETS.CSAT_360]: {
    breakdown: {
      total: 5,
      satisfied: 2,
      verySatisfied: 1,
      neutral: 2,
      dissatisfied: 0,
      veryDissatisfied: 0,
    },
    score: '60%',
  },
};
